<template>
  <div class="carStyle">
    <el-form :rules="rules" ref="form" :model="form">
      <div class="halfStyle">
        <div class="title">{{$t('BatteryStatus.baseInform')}}</div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              prop="batteryNumber"
              :label="$t('BatteryFile.batteryNumber')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.batteryNumber"
                autocomplete="off"
                class="terminalStyle"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item
              prop="carId"
              :label="$t('common.carId')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.carId"
                autocomplete="off"
                class="terminalStyle"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              prop="terminalId"
              :label="$t('common.terminalId')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.terminalId"
                autocomplete="off"
                class="terminalStyle"
              ></el-input> </el-form-item
          >
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="batteryType"
              :label="$t('BatteryFile.batteryType')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.batteryType"
                autocomplete="off"
                class="terminalStyle"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              prop="power"
              :label="$t('BatteryFile.power')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.power"
                autocomplete="off"
                class="terminalStyle"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="capacity"
              :label="$t('BatteryFile.capacity')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.capacity"
                autocomplete="off"
                class="terminalStyle"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              prop="ratedChargingSpeed"
              :label="$t('BatteryFile.ratedChargingSpeed')"
              :label-width="formLabelWidth"
            >
               <el-input
                size="small"
                disabled
                v-model="form.ratedDischargeSpeed"
                autocomplete="off"
                class="terminalStyle"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="ratedDischargeSpeed"
              :label="$t('BatteryFile.ratedChargingSpeed')"
              :label-width="formLabelWidth"
            >
              <el-input
                size="small"
                disabled
                v-model="form.ratedChargingSpeed"
                autocomplete="off"
                class="terminalStyle"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ["bindBattery"],
  data() {
    return {
      rules: {},
      form: {
        batteryNumber: "",
        carId: "",
        terminalId: "",
        batteryType: "",
        power: "",
        capacity: "",
        ratedChargingSpeed: "",
        ratedDischargeSpeed: ""
      },
      formLabelWidth: "145px",
    };
  },
  created() {
    
  },
  methods: {
    getSelectOneTerminal() {
      let param = {
        batteryNumber: this.bindBattery,
      };
      this.$store
        .dispatch("BatteryFile/GET_QUERYBATTERYINFO", param)
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.form = {
                batteryNumber: res.data.data.batteryNumber,
                carId: res.data.data.carId,
                terminalId: res.data.data.terminalId,
                batteryType: res.data.data.batteryType == null ? '' : res.data.data.batteryType == 1 ? this.$t('BatteryFile.plumbicAcid'): this.$t('BatteryFile.lithium'),
                power: res.data.data.power,
                capacity: res.data.data.capacity,
                ratedChargingSpeed: res.data.data.ratedChargingSpeed,
                ratedDischargeSpeed: res.data.data.ratedDischargeSpeed
              };
            }
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>